var map = {
	"./border.spec.js": 9,
	"./calculator/viewportColumns.spec.js": 10,
	"./calculator/viewportRows.spec.js": 11,
	"./cell/coords.spec.js": 12,
	"./cell/range.spec.js": 13,
	"./core.spec.js": 14,
	"./event.spec.js": 15,
	"./filter/column.spec.js": 16,
	"./filter/row.spec.js": 17,
	"./scroll.spec.js": 18,
	"./scrollbar.spec.js": 19,
	"./scrollbarNative.spec.js": 20,
	"./selection.spec.js": 21,
	"./settings/columnHeaders.spec.js": 22,
	"./settings/preventOverflow.spec.js": 23,
	"./settings/rowHeaders.spec.js": 24,
	"./settings/stretchH.spec.js": 25,
	"./table.spec.js": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;


//////////////////
// WEBPACK FOOTER
// ./src/3rdparty/walkontable/test/spec \.spec\.js$
// module id = 8
// module chunks = 0